import { render, staticRenderFns } from "./WhatsappCreditLow.vue?vue&type=template&id=00223b2a&scoped=true"
import script from "./WhatsappCreditLow.vue?vue&type=script&lang=js"
export * from "./WhatsappCreditLow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00223b2a",
  null
  
)

export default component.exports